var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},_vm._l((_vm.currentItems),function(item,item_index){return _c('v-chip',{key:item_index,attrs:{"color":"grey lighten","text-color":"white"}},[_vm._v(_vm._s(item)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }